function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect } from 'react';
import window from 'global/window';
/** MUI `breakpoints.up` returns `@media (…)` for styled-css; `matchMedia` needs the inner `(…)` only */ export function toMatchMediaQuery(breakpointUp) {
    return breakpointUp.replace(/^\s*@media\s+/i, '').trim();
}
var useMediaQuery = function(query) {
    var _useState = _sliced_to_array(useState(false), 2), match = _useState[0], setMatch = _useState[1];
    var matchMediaType = _type_of(window === null || window === void 0 ? void 0 : window.matchMedia);
    useEffect(function() {
        if (matchMediaType !== 'function') {
            return undefined;
        }
        var matchObject = window.matchMedia(query);
        var updateMatch = function() {
            return setMatch(matchObject.matches);
        };
        updateMatch();
        if (matchObject.addEventListener) {
            matchObject.addEventListener('change', updateMatch);
            return function() {
                matchObject.removeEventListener('change', updateMatch);
            };
        }
        matchObject.addListener(updateMatch);
        return function() {
            matchObject.removeListener(updateMatch);
        };
    }, [
        query,
        matchMediaType
    ]);
    return match;
};
export default useMediaQuery;
